/**
 * @created     2026-04-08
 * @description Temporary TODO modal for DSGVO data deletion requests.
 *              Provides a visible interim form until the final deletion form is implemented.
 *              Depends on: ChatAction modalId 'delete_form_todo' from bot response.
 */
import {
  Component,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
  signal,
  inject,
  computed,
  isDevMode,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { I18nService } from '../../../core/services/i18n.service';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-delete-form-todo-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './delete-form-todo-modal.component.html',
  styleUrl: './delete-form-todo-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteFormTodoModalComponent {
  private readonly i18n = inject(I18nService);
  @Output() close = new EventEmitter<void>();
  @Output() submitTodoForm = new EventEmitter<void>();

  readonly showDevHelper = isDevMode();
  readonly fullName = signal('');
  readonly birthDate = signal('');
  readonly deleteRequest = signal('');

  readonly isValid = computed(() => {
    return this.fullName().trim().length > 2
      && this.birthDate().trim().length > 0
      && this.deleteRequest().trim().length > 4;
  });

  onClose(): void {
    this.close.emit();
  }

  insertTestData(): void {
    if (!this.showDevHelper) return;
    this.fullName.set('TESTDATEN Max Mustermann');
    this.birthDate.set('1989-05-17');
    this.deleteRequest.set(this.i18n.t('p1.deleteRequest'));
  }

  onSubmit(): void {
    if (!this.isValid()) {
      return;
    }
    this.submitTodoForm.emit();
  }
}
